/** LIA, the Ministry of Finance AI assistant: names and wording used across the site. */
export const LIA = {
    name: 'LIA',
    brand: 'LIA AI',
    // "Lia" is word, speech or information in Tetum.
    expansion: 'Lia Informasaun Administrasaun',
    tagline: 'Ita-nia Asistente Dijitál ba Informasaun no Servisu Públiku.',
    shortTagline: 'Ita-nia Asistente Dijitál',
    taglineEnglish: 'Your digital assistant for public information and services.',
    path: '/lia',
    url: 'https://lia.mof.gov.tl/',
};

export const LIA_GREETINGS = {
    English: "Hello! I'm LIA, the Ministry of Finance's digital assistant. How can I help you today?",
    Tetum: "Ola! Ha'u mak LIA, ita-nia Asistente Dijitál husi Ministériu Finansas. Saida mak ha'u bele ajuda ohin?",
    Portuguese: 'Olá! Sou a LIA, a assistente digital do Ministério das Finanças. Como posso ajudar hoje?',
};
